import React, { useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import { ApplicationState } from "../../store";
import * as ConfigurationActions from "../../store/configurationService/actions";

const SwitchAccount: React.FunctionComponent = (props: any) => {
    const dispatch = useDispatch();
    const setRedirectToDashboard = (forceUpdate: boolean) => dispatch(ConfigurationActions.actionCreators.setRedirectToDashboard(forceUpdate));
    const needToUpdateDashboard = useSelector((state: ApplicationState) =>
        state.configurationState && state.configurationState.redirectToDashboard ? state.configurationState.redirectToDashboard : false
    );
    const routeLoading = useSelector((state: ApplicationState) => state.configurationState && (state.configurationState.loading || false));

    if (needToUpdateDashboard) {
        setRedirectToDashboard(false);
    }

    useEffect(() => {
        if (routeLoading) {
            dispatch(ConfigurationActions.actionCreators.setRouteLoading(false));
        }
    }, [dispatch, routeLoading]);

    return (
        <React.Fragment>
            <div className="row loading" id="content" style={{minHeight: "409px"}}>
                <div className="col-xs">
                    <div className="box offset-padding">
                        <div className="box-header">
                            <div className="box-title-container">
                                <div className="box-title-icon" aria-hidden="true">
                                    <i className="las la-user"></i>
                                </div>
                            </div>
                            <div className="box-description">
                                <div role="grid" className="data-grid">
                                    <div role="row" className="data-row row">
                                        <div role="gridcell" className="col-xs-12 col-sm-8 col-no-gutter">
                                            <div className="data-value" id="label-personal-information-details"></div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </React.Fragment>
    );
};

export default SwitchAccount;
